import { render, staticRenderFns } from "./FormShell.PD-10913.vue?vue&type=template&id=65b9a914"
import script from "./FormShell.PD-10913.vue?vue&type=script&lang=js"
export * from "./FormShell.PD-10913.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports